import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageCircle, UserMinus } from 'lucide-react';

const FriendList = ({ friends, onUnfriend, emptyMessage = "Noch keine Freunde hinzugefügt." }) => {
    const navigate = useNavigate();

    if (!friends || friends.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 text-center">
                <div className="text-6xl mb-4 opacity-30">👥</div>
                <h3 className="text-lg font-bold text-gray-500 dark:text-gray-400 mb-1">{emptyMessage}</h3>
                <p className="text-sm text-gray-400 dark:text-gray-500 mb-6">Finde Lernpartner und lerne gemeinsam.</p>
                <button
                    onClick={() => navigate('/friends?tab=add')}
                    className="px-6 py-3 bg-plantlix-500 hover:bg-plantlix-600 text-white rounded-2xl font-bold text-sm shadow-lg shadow-plantlix-500/20 transition-all hover:scale-105 active:scale-95"
                >
                    + Freunde finden
                </button>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {friends.map(friend => (
                <div
                    key={friend.friendship_id || friend.id}
                    className="group flex items-center gap-4 p-4 bg-white dark:bg-white/[0.03] rounded-2xl border border-gray-100 dark:border-white/[0.07] hover:border-plantlix-200 dark:hover:border-plantlix-800/50 hover:shadow-md transition-all"
                >
                    {/* Avatar */}
                    <button
                        onClick={() => navigate(`/profile/@${friend.username}`)}
                        className="relative flex-shrink-0"
                    >
                        <div className="w-14 h-14 rounded-full bg-gradient-to-br from-plantlix-400 to-plantlix-700 flex items-center justify-center text-white font-black text-xl shadow-md">
                            {friend.avatar_url ? (
                                <img src={friend.avatar_url} alt={friend.username} className="w-full h-full object-cover rounded-full" />
                            ) : (
                                friend.username.charAt(0).toUpperCase()
                            )}
                        </div>
                        {friend.is_online && (
                            <span className="absolute bottom-0.5 right-0.5 block w-3.5 h-3.5 bg-plantlix-500 rounded-full border-2 border-white dark:border-[#1a1a1a]" />
                        )}
                    </button>

                    {/* Info */}
                    <div className="flex-1 min-w-0">
                        <button
                            onClick={() => navigate(`/profile/@${friend.username}`)}
                            className="font-bold text-gray-900 dark:text-white hover:text-plantlix-600 dark:hover:text-plantlix-400 transition-colors truncate block text-left w-full"
                        >
                            {friend.username}
                        </button>
                        <div className="flex items-center gap-2 mt-1">
                            <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-plantlix-50 dark:bg-plantlix-900/20 text-plantlix-600 dark:text-plantlix-400 text-[11px] font-black rounded-lg border border-plantlix-100 dark:border-plantlix-800/30">
                                Lvl. {friend.level || 1}
                            </span>
                            <span className="text-[11px] text-gray-400">{(friend.xp_total || 0).toLocaleString()} XP</span>
                        </div>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                            onClick={() => navigate(`/sniggle/messages/${friend.user_id || friend.id}`)}
                            className="w-9 h-9 flex items-center justify-center rounded-xl text-gray-400 hover:text-plantlix-600 hover:bg-plantlix-50 dark:hover:bg-plantlix-900/20 transition-all"
                            title="Nachricht senden"
                        >
                            <MessageCircle className="w-4 h-4" />
                        </button>
                        {onUnfriend && (
                            <button
                                onClick={() => onUnfriend(friend.friendship_id, friend.username)}
                                className="w-9 h-9 flex items-center justify-center rounded-xl text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                                title="Freund entfernen"
                            >
                                <UserMinus className="w-4 h-4" />
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default FriendList;
